import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import WebformApp from './WebformApp.jsx';

const inner_gated_webform_container = document.getElementById('gated-webform');

function App() {

    return (
        <>
            <WebformApp />
        </>
    );
}

if (inner_gated_webform_container) {
    //document.body.classList.add('react-gated-webform');
    ReactDOM.render(<App />, inner_gated_webform_container);
}